import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { RestfullApiService } from "../../config/service";
import PreLoader from "../../utils/PreLoader";
import { encryptData } from "../../utils/storage";
import { MEDIA_URL } from "../../config/url";

export default function AllBlog() {
  const [fetchingBlog, setFetchingBlog] = useState(false);
  const [blogDetails, setBlogDetails] = useState([]);
  const user = useSelector((state) => state.user.userProfile);
  const navigate = useNavigate();
  async function loadEvent() {
    const reqdata = {
      Method_Name: "Get",
      Org_Id: user?.Org_Id ? user?.Org_Id : "NA",
      Session_User_Id: user?.Participant_Id ? user?.Participant_Id : "NA",
      Session_User_Name: user ? `${user?.First_Name} ${user?.Last_Name}` : "NA",
      Blog_Id: "",
      Filter: "",
    };
    try {
      setFetchingBlog(true);
      const result = await RestfullApiService(reqdata, "participant/blogs");
      if (result) {
        return result;
      }
    } catch (err) {
      alert(err);
    } finally {
      setFetchingBlog(false);
    }
  }
  useEffect(() => {
    async function fetchBlogDetails() {
      const response = await loadEvent();

      if (response) {
        console.log(response?.data?.Result);

        setBlogDetails(response?.data?.Result?.Table1);
      }
    }

    fetchBlogDetails();
  }, []);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div>
      {fetchingBlog && <PreLoader />}
      {!fetchingBlog && (
        <>
          <section
            style={{ marginTop: "90px" }}
            className="py-5 d-flex items-center bg-blue-1-05"
          >
            <div className="container">
              <div className="row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="row x-gap-10 y-gap-5 items-center text-14 fw-500 text-light-1 font-inter">
                    <div className="col-auto">
                      <a href="/" className="cursor-pointer">
                        Home
                      </a>
                    </div>
                    <div className="col-auto">
                      <div className="">{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div className="text-primary cursor-pointer">
                        All Blogs
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="pt-20">
            <div className="container">
              <div className="row y-gap-10 layout-pt-sm layout-pb-sm items-center justify-between">
                {blogDetails?.map((blog) => {
                  const encryptedParam = encryptData(blog?.Blog_Id);
                  return (
                    <div className="col-lg-4 col-sm-4">
                      <Link
                        to={`/blog/${encryptedParam}`}
                        className="blogCard -type-4 d-block bg-white px-20 py-20 rounded-16"
                      >
                        <div className="blogCard__image rounded-16 ratio ratio-2:1">
                          <img
                            className="img-ratio rounded-16 js-lazy"
                            src={`${MEDIA_URL}${blog?.Image_Path}`}
                            alt="blog"
                          />
                          <div class="cardImage__leftBadge">
                            <div class="py-5 px-15 rounded-right-4 text-13 lh-16 fw-600 uppercase bg-primary text-white">
                              {blog?.BlogType}
                            </div>
                          </div>
                        </div>
                        <div className="blogCard__content mt-10 relative">
                          <h4 className="text-15 lh-13 fw-600 text-dark-1 trim-2">
                            {blog?.Short_Description}
                          </h4>
                          <div className="text-12 text-light-1 lh-15 mt-10 trim-3 fw-500 font-inter text-justify">
                            {blog?.Long_Description}
                          </div>
                          <div className="text-12 text-light-1 lh-14 mt-15 trim-3 fw-500 font-inter">
                            <i className="far fa-calendar text-primary text-14 mr-10 fw-600"></i>
                            {blog?.Created_On}
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
}
